export function tryParseJSON(jsonString) {
    try {
        const parsedJson = JSON.parse(jsonString);
        return {
            success: true,
            json: parsedJson
        };
    } catch (error) {
        return {
            success: false,
            error: error.message
        };
    }
}
